import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { fetchBubbles } from "../Services/BubbleService";
import { IBubble } from "../Interfaces/IBubbles";

interface BubbleContextProps {
  bubbles: IBubble[] | null;
  loading: boolean;
  error: string | null;
}

const BubbleContext = createContext<BubbleContextProps | undefined>(undefined);

export const BubbleProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [bubbles, setBubbles] = useState<IBubble[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchBubbles();
        setBubbles(data);
      } catch (err) {
        setError("Impossible de charger les bulles.");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return (
    <BubbleContext.Provider value={{ bubbles, loading, error }}>
      {children}
    </BubbleContext.Provider>
  );
};

export const useBubbles = (): BubbleContextProps => {
  const context = useContext(BubbleContext);
  if (context === undefined) {
    throw new Error("useBubbles must be used within a BubbleProvider");
  }
  return context;
};
